export const clientHistory = {
  ALL: "all",
  CALL: "CL",
  MESSAGE: "SMS",
  EMAIL: "EMAIL",
  DEPOSIT: "DP",
  COMMENT: "CMM",
};

export const teamHistory = {
  ALL: "all",
  CALL: "CL",
  MESSAGE: "SMS",
  EMAIL: "EMAIL",
  DEPOSIT: "DP",
  COMMENT: "CMM",
  LOGIN: "LG",
  NEWUSER: "NEWUSER",
};

export const campaignsStatus = {
  ACTIVE: "ACTIVE",
  PAUSED: "PAUSED",
  FINISHED: "FINISHED",
};

export const PERMISSION_CODE = {
  PERMISSION_DENIED: "PD",
  SA: "SA",
  ADMIN: "ADMIN",
  ACCESS_TEAM: "00001",
  VIEW_USERS: "00002",
  CREATE_USER: "00003",
  INVITE_USER: "00004",
  EDIT_USER: "00005",
  VIEW_USER_HISTORY: "00006",
  VIEW_ROLES: "00007",
  CREATE_ROLE: "00008",
  EDIT_ROLE: "00009",
  ACCESS_CUSTOMERS: "00010",
  VIEW_CUSTOMERS: "00011",
  CREATE_CUSTOMER: "00012",
  EDIT_CUSTOMER: "00013",
  VIEW_DEPOSIT_TYPES: "00014",
  CREATE_DEPOSIT_TYPE: "00015",
  EDIT_DEPOSIT_TYPE: "00016",
  VIEW_CUSTOMER_CATEGORIES: "00017",
  VIEW_SPECIAL_CUSTOMERS: "00018",
  VIEW_SENSITIVE_CUSTOMERS: "00019",
  VIEW_CUSTOMER_HISTORY: "00020",
  ACCESS_TEMPLATES: "00021",
  VIEW_TEMPLATES: "00022",
  CREATE_TEMPLATE: "00023",
  EDIT_TEMPLATE: "00024",
  SEND_EMAILS: "00025",
  SEND_SMS: "00026",
  DO_CALLS: "00027",
  CREATE_TEAM: "00028",
  CREATE_CUSTOMER_CATEGORY: "00029",
  UPDATE_CUSTOMER_CATEGORY: "00030",
  VIEW_REFERRALS: "00031",
  EDIT_REFERRALS: "00032",
  CREATE_REFERRALS: "00033",
  ACCESS_ROLES: "00034",
  ACCESS_SENSITIVE_CUSTOMER_INFO: "00035",
  VIEW_SENSITIVE_CUSTOMER_INFO: "00036",
  CREATE_SENSITIVE_CUSTOMER_INFO: "00037",
  UPDATE_SENSITIVE_CUSTOMER_INFO: "00038",
  DEACTIVATE_ACTIVATE_CUSTOMERS: "00040",
};

export const DOCUMENT_TYPES = {
  CD: "Card",
  DC: "Document",
  ID: "Identification",
  UB: "Utility Bill",
};

export const CAMPAIGN_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  IN_PROGRESS: "IN_PROGRESS",
};

export const CAMPAIGN_TYPE = {
  EMAIL: "EMAIL",
  SMS: "SMS",
};
